export default "__VITE_ASSET___VEX3CPm__"